module.exports = __webpack_public_path__ + "media/images/bg/patterns/triangles-bb0bcd1b25c07ab7822cd788edd35006.svg";